import axios from 'shared/lib/axios'

// API Utils.
class API {
  static prefix = '/api'

  static defaultVersion = 'boomerang'

  static _request = (method, path, options = {}) => {
    let data, params
    if (method === 'get') {
      params = options
    } else {
      data = options
    }

    const url = API.path(path, options)

    delete options.apiVersion

    return axios({
      method,
      url,
      data,
      params,
      format: 'json'
    })
  }

  // Execute GET request against the API.
  static get = (path, options = {}) => {
    return API._request('get', path, options)
  }

  // Execute POST request against the API.
  static post = (path, options = {}) => {
    return API._request('post', path, options)
  }

  // Execute PATCH request against the API.
  static patch = (path, options = {}) => {
    return API._request('patch', path, options)
  }

  // Execute PUT request against the API.
  static put = (path, options = {}) => {
    return API._request('put', path, options)
  }

  // Execute DELETE request against the API.
  static delete = (path, options = {}) => {
    return API._request('delete', path, options)
  }

  // Gets collection.
  static getCollection = (name, options = {}) => {
    return API.get(name, options)
  }

  // Gets resource.
  static getResource = (name, id, options = {}) => {
    if (id) {
      return API.get(`${name}/${id}`, options)
    } else {
      return API.get(`${name}`, options)
    }
  }

  // Creates resource.
  static createResource = (name, options = {}) => {
    const apiVersion = options.apiVersion ?? API.defaultVersion

    if (apiVersion === 3 || apiVersion === 'boomerang') {
      const { attributes, ...otherParams } = options
      const data = { type: name, attributes }
      const params = { ...otherParams, data }

      return API.post(name, params)
    } else {
      return API.post(name, options)
    }
  }

  // Updates resource.
  static updateResource = (name, id, options = {}) => {
    const apiVersion = options.apiVersion ?? API.defaultVersion
    if (apiVersion === 3 || apiVersion === 'boomerang') {
      const { attributes, ...otherParams } = options
      const data = { type: name, id, attributes }
      const params = { ...otherParams, data }

      return API.patch(`${name}/${id}`, params)
    } else {
      return API.put(`${name}/${id}`, options)
    }
  }

  // Deletes resource.
  static deleteResource = (name, id, options = {}) => {
    return API.delete(`${name}/${id}`, options)
  }

  // Append path to api prefix and version.
  static path = (append, options = {}) => {
    const apiVersion = options.apiVersion ?? API.defaultVersion
    const path = `${API.prefix}/${apiVersion}`

    if (append && append.length > 0) {
      return `${path}/${append}`
    } else {
      return path
    }
  }
}

export default API
